import RequestService from '../request-service';

export default class NotificationsService extends RequestService {
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.seenNotify;
    this.method = 'get';

    this.getParams = {
      id: null,
    };
    const { authorizationHeaders } = this.$config;
    this.headers = authorizationHeaders;
    this.addHeader('ExternalUserID', APP_SETTINGS.player.id);
  }
}
